import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/toolbox")({
  component: ToolboxLayout,
});

function ToolboxLayout() {
  return <Outlet />;
}
